import { render, staticRenderFns } from "./StatsBar.vue?vue&type=template&id=797caaf1&scoped=true&lang=pug"
import script from "./StatsBar.vue?vue&type=script&lang=js"
export * from "./StatsBar.vue?vue&type=script&lang=js"
import style0 from "./StatsBar.vue?vue&type=style&index=0&id=797caaf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797caaf1",
  null
  
)

export default component.exports